import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../nest-api";
import { ResponseData } from "../../nest-responses";
import { RequestGetMyScoreDto, ResponseGetMyScoreDto } from "../dto/leaderboard.dto";

@Injectable()
export class LeaderBoardNestApi {
  private service: string = '';
  private model: string = 'leaderboard';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {
  }

  public getMyScore(payload: RequestGetMyScoreDto): Observable<ResponseData<ResponseGetMyScoreDto[]>> {
    const method: string = 'POST';
    const func: string = 'getMyScore';
    const params: any = payload;
    const urlParams: any = {}
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetMyScoreDto[]>>(method, url, params, urlParams, body, null, null, null, false);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/leaderboard.api.ts